import React from "react";
import "./Rim-Widgets.css";
import UserLoginSummary from "../../../../components/Cybershield-component/Donut-user-login-summary/user-login-summary";
import CardRim  from "../../../../components/Cybershield-component/RIM_CARD/Rim-card";
import LoginActivityChart from "../../../../components/Cybershield-component/Bar-Login-Activity/Bar-login-activity";
import ConfigurationChangeEvent from "../../../../components/Cybershield-component/Bar-Configuration-change-event/Bar-configuration-change-event";
import AssetModelSummary from "../../../../components/Cybershield-component/Donut-asset-model-summary/asset-model-summary";
import EventSummary from "../../../../components/Cybershield-component/Donut-event-summary/Event-summary";
import widgetConfig from "./Rim-widget-config.json";
import SecurityNotifications from "../../../../components/Cybershield-component/Security-notifications/security-notification";
function RimWidgets() {
    return (
        
            <div className="rim-widget-container">
             
             {widgetConfig.SecurityNotifications.isEnabled && (
                <CardRim 
                    widgetName={widgetConfig.SecurityNotifications.widgetName }
                    widgetUpdateTime={widgetConfig.SecurityNotifications.widgetUpdateTime}
                    component={<SecurityNotifications />}
                    applyScroll={widgetConfig.SecurityNotifications.applyScroll}
                ></CardRim >
             )}
                 {widgetConfig.UserLoginSummary.isEnabled && (
                  <CardRim 
                    widgetName={widgetConfig.UserLoginSummary.widgetName}
                    widgetUpdateTime={widgetConfig.UserLoginSummary.widgetUpdateTime}
                    component={<UserLoginSummary />}
                    applyScroll={widgetConfig.UserLoginSummary.applyScroll}
                ></CardRim >
                 )}
                 {widgetConfig.LoginActivity.isEnabled && (
                <CardRim 
                    widgetName={widgetConfig.LoginActivity.widgetName}
                    widgetUpdateTime={widgetConfig.LoginActivity.widgetUpdateTime}
                    component={<LoginActivityChart/>}
                    applyScroll={widgetConfig.LoginActivity.applyScroll}
                ></CardRim >
                 )}
                {widgetConfig.AssetModelSummary.isEnabled && (
                <CardRim 
                    widgetName={widgetConfig.AssetModelSummary.widgetName}
                    widgetUpdateTime={widgetConfig.AssetModelSummary.widgetUpdateTime}
                    isTimePeriod={true}
                    component={<AssetModelSummary/>}
                    applyScroll={widgetConfig.AssetModelSummary.applyScroll}
                ></CardRim >
                )}
                {widgetConfig.EventSummary.isEnabled && (
                <CardRim 
                    widgetName={widgetConfig.EventSummary.widgetName}
                    widgetUpdateTime={widgetConfig.EventSummary.widgetUpdateTime}
                    component={<EventSummary />}
                    applyScroll={widgetConfig.EventSummary.applyScroll}
                ></CardRim >
                )}
                {widgetConfig.ConfigChangeEvents.isEnabled && (
               <CardRim 
                    widgetName={widgetConfig.ConfigChangeEvents.widgetName}
                    widgetUpdateTime={widgetConfig.ConfigChangeEvents.widgetUpdateTime}
                    component={<ConfigurationChangeEvent />}
                    applyScroll={widgetConfig.ConfigChangeEvents.applyScroll}
                ></CardRim >
                )}
              

            </div>
       
    );
}

export default RimWidgets;
